/**
 * Wrapper class for internal queue event payloads.
 * Used to mark queue-emitted events so regex listeners can skip them.
 * When listening to queue events, unwrap via `event.data`.
 */ export class InternalQueueEvent {
    data;
    constructor(data){
        this.data = data;
    }
}
export var QueueRejectionReason = /*#__PURE__*/ function(QueueRejectionReason) {
    QueueRejectionReason["full"] = "Queue is full";
    QueueRejectionReason["notRunning"] = "Queue is not running";
    return QueueRejectionReason;
}({});
